import React, { useEffect } from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import Fab from '@material-ui/core/Fab';
import Tooltip from '@material-ui/core/Tooltip';
import Videocam from '@material-ui/icons/Videocam';
import VideocamOff from '@material-ui/icons/VideocamOff';

import useScreenShareToggle from '../../../hooks/useScreenShareToggle/useScreenShareToggle';
import useLocalVideoToggle from '../../../hooks/useLocalVideoToggle/useLocalVideoToggle';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    fab: {
      margin: theme.spacing(1),
    },
  })
);

export default function ToggleVideoButton(props: { disabled?: boolean }) {
  const classes = useStyles();
  const [isVideoEnabled, toggleVideoEnabled] = useLocalVideoToggle();
  const [isScreenShared, toggleScreenShare] = useScreenShareToggle();

  useEffect(() => {
    if (isVideoEnabled) {
      if (isScreenShared) toggleScreenShare();
    }
  });

  return (
    <Tooltip
      title={isVideoEnabled ? 'Mute Video' : 'Unmute Video'}
      placement="top"
      PopperProps={{ disablePortal: true }}
    >
      <Fab className={classes.fab+" call-control-buttons"} onClick={toggleVideoEnabled} disabled={props.disabled}>
        {isVideoEnabled ? <Videocam style={{ color: "white" }}  /> : <VideocamOff style={{ color: "white" }}  />}
      </Fab>
    </Tooltip>
  );
}
